import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type ToastVariant = 'default' | 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  variant: ToastVariant;
  duration: number;
  removing?: boolean;
}

@Injectable()
export class ToastService {
  private counter = 0;
  readonly toast$ = new Subject<Toast>();

  show(message: string, variant: ToastVariant = 'default', duration = 3000) {
    this.toast$.next({ id: ++this.counter, message, variant, duration });
  }

  success(message: string, duration = 3000) { this.show(message, 'success', duration); }
  error(message: string, duration = 4000) { this.show(message, 'error', duration); }
  warning(message: string, duration = 3000) { this.show(message, 'warning', duration); }
  info(message: string, duration = 3000) { this.show(message, 'info', duration); }
}
